var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heads") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.6,60a54.61206,54.61206,0,0,1-102,27.108,53.80039,53.80039,0,0,1-5.988-15.612A54.94484,54.94484,0,0,1,5.4,60,54.63072,54.63072,0,0,1,73.284,7.032a53.6595,53.6595,0,0,1,15.384,6.504A54.62611,54.62611,0,0,1,114.6,60Z",
    style: {
      fill: "#ffde50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,60a44.98374,44.98374,0,0,1-42.684,44.94H62.28c-.756.036-1.512.06-2.28.06a45.00313,45.00313,0,0,1-7.716-89.34h.036A44.98939,44.98939,0,0,1,105,60Z",
    style: {
      fill: "#f68e00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6,60.6a44.99555,44.99555,0,0,1-37.284,44.34H62.28c-.756.036-1.512.06-2.28.06a45.00313,45.00313,0,0,1-7.716-89.34h.036c.756-.036,1.512-.06,2.28-.06a44.98562,44.98562,0,0,1,45,45Z",
    style: {
      fill: "#faa300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.804,22.59595l-6.78,6.78-3.096,3.096L29.376,93.024l-6.78,6.78A54.42023,54.42023,0,0,1,13.8,88.308,53.80039,53.80039,0,0,1,7.812,72.696,54.94484,54.94484,0,0,1,6.6,61.2,54.63072,54.63072,0,0,1,74.484,8.232a53.6595,53.6595,0,0,1,15.384,6.504A54.36778,54.36778,0,0,1,99.804,22.59595Z",
    style: {
      fill: "#fff",
      opacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(28.09668 67.95879)",
    style: {
      fontSize: "21.072948455810547px",
      fill: "#b96b00",
      fontFamily: "Roboto-Bold, Roboto",
      fontWeight: 700,
      letterSpacing: "-0.014574557845763338em"
    }
  }, "T", /*#__PURE__*/React.createElement("tspan", {
    x: 12.72949,
    y: 0,
    style: {
      letterSpacing: "0.04397855451710463em"
    }
  }, "AILS")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(29.29687 69.15898)",
    style: {
      fontSize: "21.072948455810547px",
      fill: "#ffea94",
      fontFamily: "Roboto-Bold, Roboto",
      fontWeight: 700,
      letterSpacing: "-0.014574557845763338em"
    }
  }, "T", /*#__PURE__*/React.createElement("tspan", {
    x: 12.72949,
    y: 0,
    style: {
      letterSpacing: "0.04397855451710463em"
    }
  }, "AILS")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTails);
export default __webpack_public_path__ + "static/media/tails.d76446c09aa054bf919a4e936e6ab183.svg";
export { ForwardRef as ReactComponent };